import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {ApiService} from '../../../../utils/services/api.service';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/of';

@Injectable()
export class ProviderCharacteristicResolverService implements Resolve<any> {

  private FLIGHT_PROVIDERS: Array<string> = ['PegasusProvider', 'SunExpressProvider', 'BoraJetProvider', 'THYProvider', 'AtlasJetProvider'];

  constructor(private apiService: ApiService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): any {

    let providers: Array<Provider> = [];

    this.FLIGHT_PROVIDERS.forEach((item) => {
      let provider: Provider = new Provider();
      provider.name = item;
      provider.classes = [];
      providers.push(provider);
    });


    return this.apiService.getProviderCharacteristicList()
      .map((response) => {

        response.data.data.rows.forEach((item) => {
          if (providers.findIndex((provider: Provider) => provider.name === item.provider) === -1) {

            let provider: Provider = new Provider();
            provider.name = item.provider;
            provider.classes = [];

            let providerClass: ProviderClass = new ProviderClass();
            providerClass.name = item.class;

            switch (item.key) {
              case 'baggage':
                providerClass.baggage = item;
                break;

              case 'isRefundable':
                providerClass.isRefundable = item;
                break;

              case 'rule':
                providerClass.ruleText = item;
                break;
            }

            provider.classes.push(providerClass);
            providers.push(provider);

          } else {

            if (providers.find((provider: Provider) => provider.name === item.provider).classes.findIndex((providerClass: ProviderClass) => providerClass.name === item.class) === -1) {

              let providerClass: ProviderClass = new ProviderClass();
              providerClass.name = item.class;

              switch (item.key) {
                case 'baggage':
                  providerClass.baggage = item;
                  break;

                case 'isRefundable':
                  providerClass.isRefundable = item;
                  break;

                case 'rule':
                  providerClass.ruleText = item;
                  break;
              }

              providers.find((provider: Provider) => provider.name === item.provider).classes.push(providerClass);
            } else {
              switch (item.key) {
                case 'baggage':
                  providers.find((provider: Provider) => provider.name === item.provider).classes.find((providerClass: ProviderClass) => providerClass.name === item.class).baggage = item;
                  break;

                case 'isRefundable':
                  providers.find((provider: Provider) => provider.name === item.provider).classes.find((providerClass: ProviderClass) => providerClass.name === item.class).isRefundable = item;
                  break;

                case 'rule':
                  providers.find((provider: Provider) => provider.name === item.provider).classes.find((providerClass: ProviderClass) => providerClass.name === item.class).ruleText = item;
                  break;
              }
            }
          }
        });

        return providers;
      }).catch((error) => {
        return Observable.of([]);
      });
  }

}

export class Provider {
  name: string;
  classes: Array<ProviderClass>;

}

export class ProviderClass {
  name: string;
  baggage: ProviderParameter;
  isRefundable: ProviderParameter;
  ruleText: ProviderParameter;

}

export class ProviderParameter {
  id: number;
  provider: string;
  class: string;
  key: string;
  value: string;
  context: string;
}



// WEBPACK FOOTER //
// C:/Biziclick/bizisystem/src/app/main/pages/provider-characteristic/resolver/provider-characteristic-resolver.service.ts